import { ISettingsContextValue } from '@wix/tpa-settings';

type GetContentParams = {
  settings: Partial<ISettingsContextValue>;
  settingsParam: any;
};

export const getContent = ({ settings, settingsParam }: GetContentParams) => {
  return (
    settings.get?.(settingsParam)?.trim() ||
    settings.getDefaultValue?.(settingsParam)
  );
};
